import type { FontFamilyProvider } from '../data/v1'

export const SYSTEM_FONT_STACK = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'

/**
 * Resolves font family fields to a CSS font-family string.
 * Returns undefined when no explicit font-family should be set.
 */
export function resolveFontFamilyCSS(
	provider: FontFamilyProvider,
	googleFamily: string,
	customName?: string,
): string | undefined {
	switch (provider) {
		case 'system':
			return SYSTEM_FONT_STACK
		case 'google-fonts':
			return googleFamily ? `"${googleFamily}", ${SYSTEM_FONT_STACK}` : undefined
		case 'custom':
			return customName ? `"${customName}", ${SYSTEM_FONT_STACK}` : undefined
	}
}
